// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__5srvf","buttons":"RemoveExpirationActionButtons_buttons__kFxCO"};